import { AiOutlineCheckCircle, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import {FaClipboardList, FaCloudUploadAlt, FaCog, FaReceipt} from 'react-icons/fa';
import { type ActionItem } from '../../../common/constants';
import { type Device } from '../../../common/types';
import ListDeviceItem from './ListDeviceItem';

interface IProps {
  items: Device[];
  pageType: 'confirmed' | 'pending';
  toggleEditModal: () => any;
  toggleDeleteModal: () => any;
  toggleApproveModal: () => any;
  toggleApiConfigModal: () => any;
  handleSelectItem: (item: Device) => any;
  handleEditingItem: (item: Device) => any;
  handleDeletingItem: (item: Device) => any;
  handleApprovingItem: (item: Device) => any;
}

const ListDevices: React.FC<IProps> = ({
  items: devices,
  toggleEditModal,
  toggleDeleteModal,
  toggleApproveModal,
  toggleApiConfigModal,
  handleSelectItem,
  handleEditingItem,
  handleDeletingItem,
  handleApprovingItem
}) => {
  const editItemHandler = (item: Device): void => {
    toggleEditModal();
    handleEditingItem(item);
  };

  const deleteItemHandler = (item: Device): void => {
    toggleDeleteModal();
    handleDeletingItem(item);
  };

  const apiConfigHandler = (item: Device): void => {
    toggleApiConfigModal();
    handleSelectItem(item);
  };

  const approveItemHandler = (item: Device): void => {
    toggleApproveModal();
    handleApprovingItem(item);
  };

  const getActionsList = (device: Device): any[] => {
    const actions: ActionItem[] = [];
    if (device.isConfirmed) {
      actions.push(
        {
          type: 'component',
          label: 'Attach Config',
          icon: (
            <button>
              <span className="px-1 h-full">
                <FaCloudUploadAlt
                  size={18}
                  onClick={() => {
                    apiConfigHandler(device);
                  }}
                />
              </span>
            </button>
          )
        },
        {
          type: 'link',
          label: 'Attach Rule',
          link: `/admin/rules/device/${device.id}`,
          icon: <FaClipboardList size={18} />
        },
        {
          type: 'link',
          label: 'Attach Sample Receipt',
          link: `/admin/devices/${device.id}/sample-receipts`,
          icon: <FaReceipt size={18} />
        },
        {
          type: 'link',
          label: 'Configuration',
          link: `/admin/configurations/device/${device.id}`,
          icon: <FaCog size={18} />
        },
        {
          type: 'component',
          label: 'Edit',
          icon: (
            <button>
              <span className="px-1 h-full">
                <AiOutlineEdit
                  color="blue"
                  size={18}
                  onClick={() => {
                    editItemHandler(device);
                  }}
                />
              </span>
            </button>
          )
        }
      );
    } else {
      actions.push(
        {
          type: 'component',
          label: 'Approve',
          icon: (
            <button
              onClick={() => {
                approveItemHandler(device);
              }}
              className="text-gray-50 text-sm text-center rounded-md"
            >
              <span className="px-1 h-full">
                <AiOutlineCheckCircle color="green" size={18} />
              </span>
            </button>
          )
        },
        {
          type: 'component',
          label: 'Delete',
          icon: (
            <button
              onClick={() => {
                deleteItemHandler(device);
              }}
              className="text-gray-50 text-sm text-center rounded-md"
            >
              <span className="px-1 h-full">
                <AiOutlineDelete color="red" size={18} />
              </span>
            </button>
          )
        }
      );
    }

    return actions;
  };

  return (
    <>
      <div className="w-full p-2 my-2 overflow-auto rounded-md">
        <table className="w-full p-4 border-b-2 border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="w-12 p-2 pl-8 text-sm font-semibold text-left">Name</th>
              <th className="w-12 p-2 pl-8 text-sm font-semibold text-left">Email</th>
              <th className="w-24 p-2 text-sm font-semibold text-left whitespace-nowrap">Description</th>
              <th className="w-4 p-2 text-sm font-semibold tracking-wide">Actions</th>
            </tr>
          </thead>
          <tbody className="">
            {devices.map((device) => {
              return <ListDeviceItem key={device.id} item={device} actions={getActionsList(device)} />;
            })}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ListDevices;
